import { createContext, useState, useEffect, useContext, useMemo } from "react";
import Cookie from "js-cookie";
import axios from "axios";
import { BaseUrlApi, ErrorMessage } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useLanguage } from "./LanguageContext";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const userToken = Cookie.get("token");
  const navigate = useNavigate();

  const [token, setToken] = useState(userToken);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [timeZone, setTimeZone] = useState("");

  useEffect(() => {
    if (userToken) setToken(userToken);
  }, [userToken]);

  useEffect(() => {
    if (userToken) {
      const getProfile = async () => {
        try {
          setLoading(true);
          const { data } = await axios.get(`${BaseUrlApi}/me`);
          setUser(data);
        } catch (error) {
          Cookie.remove("token");
          setUser(null);
          navigate("/login");
          toast("Error", {
            description: ErrorMessage(error),
          });
        } finally {
          setLoading(false);
        }
      };
      getProfile();
    } else {
      setLoading(false);
    }
  }, [userToken]);

  useEffect(() => {
    const urlToken = new URLSearchParams(window.location.search).get("token");
    if (urlToken) {
      Cookie.set("token", urlToken);
    }
  }, []);

  // Logout function
  const logout = () => {
    setUser(null);
    setToken(null);
    Cookie.remove("token");
    navigate("/login", { replace: true });
  };

  const { changeLanguage } = useLanguage();

  // Send Timezone
  useMemo(() => {
    console.log("callBack Timezone");
    fetch("https://ipinfo.io/json")
      .then((response) => response.json())
      .then((data) => {
        setTimeZone(data.timezone);
      })
      .catch((error) => {
        console.error("Error fetching IP info:", error);
      });
  }, [changeLanguage, timeZone]);

  return (
    <AuthContext.Provider value={{ user, token, loading, logout, timeZone }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
